<template>
  <v-container fluid class="p-0 statistics-table">
    <simple-numeric-input
      @confirm="confirmEditPointsDialog"
      @resetArbitraryPointsDialog="resetArbitraryPointsDialog"
      ref="numbericinput"
      :dialog="editPointDialog"
      labelText="Puntos"
      :default="selectedTeam ? selectedTeam.arbitrary_points : 0"
      positiveText="Guardar"
      :realPoints="selectedTeam ? selectedTeam.real_points : null"
    ></simple-numeric-input>

    <!-- Vista de tabla general normal -->
    <v-data-table
      v-if="currentTournament.mode == 'normal'"
      :rows-per-page-items="[25,50,100]"
      :headers="headers"
      :items="currentGeneralTable"
      class="elevation-1 responsive-table-sm"
      light
      hide-actions
      no-results-text
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip left v-if="props.header.tooltip">
          <span slot="activator">{{ props.header.text }}</span>
          <span>{{ props.header.desc }}</span>
        </v-tooltip>
        <span v-else>{{ props.header.text }}</span>
      </template>

      <template slot="items" slot-scope="props">
        <td class="text-md-right text-xs-center sticky-cell">{{ props.item.position }}</td>
        <td class="text-xs-right sticky-cell">
          <span class="px-2 crop-text">{{ props.item.name }}</span>
        </td>
        <td class="text-md-right text-xs-center">{{ props.item.matches_played }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.matches_won }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.draw_matches }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.matches_lost }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.goals }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.received_goals }}</td>
        <td class="text-md-right text-xs-center">{{ props.item.difference_of_goals }}</td>
        <td class="text-md-right text-xs-center">
          <div class="d-flex controls-cell final-points-div">
            <span v-if="!props.item.draw_points">{{ props.item.final_points }}</span>

            <v-tooltip left v-if="props.item.draw_points">
              <span slot="activator">{{ props.item.final_points }}</span>
              <span>Puntos extra por empate ganado en penales: {{ props.item.draw_points || 0 }}</span>
            </v-tooltip>
            
            <v-btn @click.native="showEditPointDialog(props.item)" flat small icon color="green">
              <v-icon small :color="props.item.points_changed ? 'warning' : 'success'">edit</v-icon>
            </v-btn>
          </div>
        </td>
      </template>
    </v-data-table>

    <!-- Vista de tabla general en grupos -->
    <section v-if="currentTournament.mode == 'groups'">
      <div class="mb-4" v-for="(group, i) in currentGroupedGeneralTable" :key="i">
        <h5 class="my-1">{{group.name}}</h5>
        <v-data-table
            :rows-per-page-items="[25,50,100]"
            :headers="headers"
            :items="group.general_table"
            class="elevation-1 responsive-table-sm"
            light
            hide-actions
            no-results-text>

            <template slot="headerCell" slot-scope="props">
              <v-tooltip left v-if="props.header.tooltip">
                <span slot="activator">{{ props.header.text }}</span>
                <span>{{ props.header.desc }}</span>
              </v-tooltip>
              <span v-else>{{ props.header.text }}</span>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-md-right text-xs-center sticky-cell">{{ props.item.position }}</td>
              <td class="text-xs-right sticky-cell">
                <span class="px-2 crop-text">{{ props.item.name }}</span>
              </td>
              <td class="text-md-right text-xs-center">{{ props.item.matches_played }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.matches_won }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.draw_matches }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.matches_lost }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.goals }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.received_goals }}</td>
              <td class="text-md-right text-xs-center">{{ props.item.difference_of_goals }}</td>
              <td class="text-md-right text-xs-center">
                <div class="d-flex controls-cell final-points-div">
                  <span v-if="!props.item.draw_points">{{ props.item.final_points }}</span>

                  <v-tooltip left v-if="props.item.draw_points">
                    <span slot="activator">{{ props.item.final_points }}</span>
                    <span>Puntos extra por empate ganado en penales: {{ props.item.draw_points || 0 }}</span>
                  </v-tooltip>

                  <v-btn
                    @click.native="showEditPointDialog(props.item)"
                    flat
                    small
                    icon
                    color="green"
                  >
                    <v-icon
                      small
                      :color="props.item.points_changed ? 'warning' : 'success'"
                    >edit</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
      </div>
    </section>
  </v-container>
</template>

<script>
import SimpleNumericInput from "@/components/helpers/modals/SimpleNumericInput";
import { mapActions, mapGetters } from "vuex";
import Utils from "@/utils/utils";
export default {
  name: "PositionsTable",
  props: {
    tournamentid: { required: true, default: -1 }
  },
  data() {
    return {
      editPointDialog: false,
      selectedTeam: null,
      headers: [
        { text: "#", value: "position", tooltip: false, desc: "#" },
        { text: "Equipo", value: "team", tooltip: false, desc: "Equipo" },
        { text: "JJ", value: "games", tooltip: true, desc: "Juegos Jugados" },
        {
          text: "JG",
          value: "wonGames",
          tooltip: true,
          desc: "Juegos Ganados"
        },
        {
          text: "JE",
          value: "tiedGames",
          tooltip: true,
          desc: "Juegos Empatados"
        },
        {
          text: "JP",
          value: "lostGames",
          tooltip: true,
          desc: "Juegos Perdidos"
        },
        { text: "GF", value: "goals", tooltip: true, desc: "Goles a Favor" },
        {
          text: "GC",
          value: "goalsAgainst",
          tooltip: true,
          desc: "Goles en Contra"
        },
        {
          text: "DIF",
          value: "dif",
          tooltip: true,
          desc: "Diferencia de Goles"
        },
        { text: "PTS", value: "points", tooltip: true, desc: "Puntos" }
      ],
      teams: [
        /*{
          position: 1,
          team: 'PITZ',
          games: 0,
          wonGames: 0,
          tiedGames: 0,
          lostGames: 0,
          goals: 0,
          goalsAgainst: 0,
          dif: 0,
          points: 0
          },
          {
          position: 2,
          team: 'Amplemind',
          games: 0,
          wonGames: 0,
          tiedGames: 0,
          lostGames: 0,
          goals: 0,
          goalsAgainst: 0,
          dif: 0,
          points: 0
          },*/
      ]
    };
  },
  created() {
    //do something after creating vue instance
    if (this.tournamentid > 0) {
      if (this.currentTournament.mode == "normal") {
        this.loadGeneralTable(this.tournamentid);
      } else if (this.currentTournament.mode == "groups") {
        this.loadGroupedGeneralTable(this.tournamentid);
      }
    }
  },
  methods: {
    ...mapActions([
      "loadGeneralTable",
      "loadGroupedGeneralTable",
      "updateArbitraryPoints",
      "resetArbitraryPoints"
    ]),
    showEditPointDialog(team) {
      this.selectedTeam = team;
      this.editPointDialog = true;
    },
    confirmEditPointsDialog(response, value) {
      this.editPointDialog = false;
      if (response && value !== 0) {
        let data = {
          tournamentId: this.tournamentid,
          teamId: this.selectedTeam.id,
          finalPoints: value,
          tournamentMode: this.currentTournament.mode
        };
        this.updateArbitraryPoints(data);
      }
    },
    resetArbitraryPointsDialog(response) {
      this.editPointDialog = false;
      let data = {
          tournamentId: this.tournamentid,
          teamId: this.selectedTeam.id,
          tournamentMode: this.currentTournament.mode
        };
      this.resetArbitraryPoints(data);
    }
  },
  computed: {
    ...mapGetters([
      "currentGeneralTable",
      "currentGroupedGeneralTable",
      "currentTournament"
    ])
  },
  mounted() {
    Utils.setTableOverflowClass(".statistics-table .responsive-table-sm");
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/tables-placeholder-selectors";

.p-0 {
  padding: 0;
}

.final-points-div {
  align-items: center;
}

.statistics-table {
  th:nth-child(2),
  .sticky-cell {
    @extend %sticky-cell;
    top: auto;
    left: 0;
  }

  .has-scroll th:nth-child(2),
  .has-scroll .sticky-cell {
    @extend %sticky-cell-has-shadow;
  }
}

@media screen and (max-width: $mobile-md-breakpoint) {
  .statistics-table {
    table.datatable th:not(:first-child):not(:nth-child(2)) {
      text-align: center !important;
    }

    .datatable.table th:nth-child(2) {
      padding-right: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/statistics/PositionsTable.vue